import Link from 'next/link'
import { Accordion } from 'react-bootstrap'
import { FaAngleRight } from 'react-icons/fa'
import styles from '~/styles/_pricing.module.scss'

type QAndA = {
  question: string
  answer: React.ReactNode
}

const QAndAs: QAndA[] = [
  {
    question: '無料体験で費用は取られませんか？',
    answer: (
      <p>
        はい、無料体験中に解約をした場合は、費用が取られることはありません。解約をされなかった場合は、無料体験終了時にご契約頂いたプランの価格をご請求いたします。
      </p>
    ),
  },
  {
    question: '無料体験の期間はどれくらいですか？',
    answer: (
      <p>
        1週間です。7日間(7 × 24時間)に満たない状態で決済されることはありません。
      </p>
    ),
  },
  {
    question: '契約の途中でプランの変更はできますか？',
    answer: (
      <p>
        はい、いつでもプランの変更が可能です。途中でプランを変更したとしても、お客様に不利益がないように、契約の残り日数を計算して、次回以降のお支払い時に自動で割引する仕組みとなっております。もし、プランを変更する前にキャンセルしてしまい、契約日数が残っている場合は、プランを再開した上でプランの変更をしてください。
      </p>
    ),
  },
  {
    question: 'キャンセルはできますか？',
    answer: (
      <p>
        はい、いつでもキャンセル可能です。キャンセルするには、ヘッダー右上のユーザアイコンを押し、プラン表示領域内の管理を押して、Stripeの管理画面を開きます。その後、Stripeの管理画面の案内に従って、キャンセルのお手続きをしてください。
      </p>
    ),
  },
  {
    question: 'キャンセル後に再開することはできますか？',
    answer: (
      <p>
        はい、いつでも再開可能です。再開するには、ヘッダー右上のユーザアイコンを押し、プラン表示領域内の管理を押して、Stripeの管理画面を開きます。その後、Stripeの管理画面の案内に従って、プラン更新のお手続きをしてください。
      </p>
    ),
  },
  {
    question: '限定公開したコンテンツはキャンセルしても公開されませんか？',
    answer: (
      <p>
        はい、公開されません。ただし、限定公開したコンテンツを編集するには、再度プレミアムプランの契約が必要です。
      </p>
    ),
  },
  {
    question: '支払いは安全ですか？',
    answer: (
      <p>
        はい。お客様のお支払い情報は、信頼性の高い決済代行業者であるStripe様に直接送信され、安全に保管されております。本サービスのサーバーでお客様のお支払い情報を取り扱うことはございません。
      </p>
    ),
  },
  {
    question: '領収書は発行できますか？',
    answer: (
      <p>
        はい、可能です。発行するためには、ヘッダー右上のユーザアイコンを押し、プラン表示領域内の管理を押して、Stripeの管理画面を開きます。その後、Stripeの管理画面の案内に従って領収書の発行手続きをしてください。
      </p>
    ),
  },
  {
    question: '支払い方法は何に対応していますか？',
    answer: <p>クレジットカードによる決済に対応しております。</p>,
  },
  {
    question: '団体プランでは請求書を発行できますか？',
    answer: (
      <p>
        はい、可能です。団体プランでご契約いただいた代表者様に請求の度に送信させていただきます。
      </p>
    ),
  },
  {
    question: '団体プランでは口座振込に対応していますか？',
    answer: (
      <p>
        はい、対応しております。ただし、振り込み手数料はお客様持ちとさせて頂いております。
      </p>
    ),
  },
  {
    question: '特定商取引法はどこから確認できますか？',
    answer: (
      <p>
        <Link href="/tradelaw" target="_blank" rel="noopener noreferrer">
          <a>こちら</a>
        </Link>
        から確認することができます。
      </p>
    ),
  },
  {
    question: '利用規約やプライバシーポリシーはどこから確認できますか？',
    answer: (
      <p>
        利用規約は
        <Link href="/terms" target="_blank" rel="noopener noreferrer">
          <a>こちら</a>
        </Link>
        から、プライバシーポリシーは
        <Link href="/privacy" target="_blank" rel="noopener noreferrer">
          <a>こちら</a>
        </Link>
        から確認することができます。
      </p>
    ),
  },
]

export const FAQSection = () => (
  <section
    key="FAQ"
    className={`${styles['bg-gray']} py-7  px-6`}
    style={{ padding: '0px 32px' }}
  >
    <div className="mx-auto" style={{ maxWidth: 840 }}>
      <h2 className={styles.h2}>よくある質問</h2>
      <Accordion className="mb-6">
        {QAndAs.map((qa, index) => (
          <Accordion.Item
            key={qa.question}
            eventKey={`${index + 1}`}
            className="bg-transparent border-start-0 border-end-0"
          >
            <Accordion.Button className="bg-transparent">
              {qa.question}
            </Accordion.Button>
            <Accordion.Body className="bg-white">{qa.answer}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
      <p className="text-center">
        <Link href={'/inquiry'} passHref>
          <a className="d-inline-flex align-items-center">
            その他お問い合わせはこちら
            <FaAngleRight />
          </a>
        </Link>
      </p>
    </div>
  </section>
)
